// config/api.ts
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const apiClient = {
  async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const __isDev = process.env.NODE_ENV === 'development';
    const token = localStorage.getItem('authToken');
    
    // Build headers safely so callers can't accidentally overwrite defaults by passing options with headers
  const callerHeaders = (options && (options as any).headers) || {};

    // If body is FormData we must not set Content-Type (browser will set the boundary)
    const isFormData = options.body instanceof FormData;

    const headers: Record<string, string> = {
      // caller headers may include Authorization or other custom headers
      ...callerHeaders,
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    // Only set Content-Type to application/json when body is present and not FormData
    if (!isFormData && options.body !== undefined && options.body !== null) {
      // don't overwrite if caller explicitly provided Content-Type
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    // Prepare body: if it's an object (and not FormData or already a string), stringify it
    let bodyToSend: any = options.body;
    if (!isFormData && bodyToSend !== undefined && bodyToSend !== null && typeof bodyToSend !== 'string') {
      try {
        bodyToSend = JSON.stringify(bodyToSend);
      } catch (e) {
        // If stringify fails, leave original body and let fetch handle/report
      }
    }

    const config: RequestInit = {
      ...options,
      headers,
      body: bodyToSend,
    };

    try {
      // Dev-only: log request details
      if (__isDev) {
        try {
          // Request logging disabled
        } catch (e) {
          // ignore logging errors
        }
      }

      const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

      // Response logging disabled

      if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }

        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        let errorData: any = undefined;

        try {
          errorData = await response.json();
          errorMessage = errorData?.message || errorMessage;
          // Error body logging disabled
        } catch (e) {
          // Se não conseguir fazer parse do JSON, usa a mensagem padrão
        }

        const err: any = new Error(errorMessage);
        err.status = response.status;
        if (errorData !== undefined) err.body = errorData;
        throw err;
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const parsed = await response.json();
        // Response body logging disabled
        return parsed;
      }

      // Para respostas não-JSON (como arquivos), retorna o response como any
      return response as any;
    } catch (error) {
      // Tratar erros de conectividade
      if (error instanceof TypeError && error.message.includes('fetch')) {
        throw new Error(`Erro de conexão: Não foi possível conectar ao servidor AIXA em ${API_BASE_URL}. Verifique se o backend está rodando.`);
      }

      // Re-lançar outros erros
      throw error;
    }
  }
};